export default __webpack_public_path__ + "68b86cee258a662920aca18f36ab2a9c.svg";